import React from 'react';
import PropTypes from 'prop-types';
import Picture from 'components/Picture';
import AIMS_FLAVORS from 'lib/aimsFlavors';

// TODO: Update this image map to urls without hashes when the CMS supports that functionality
const imageUrlMap = {
  today: 'https://media1.s-nbcnews.com/i/newscms/2019_03/2717326/today_c013724f62a64c50bed13c145d5d9342.jpg',
  news: 'https://media3.s-nbcnews.com/i/newscms/2019_03/2717316/nbcnews_c013724f62a64c50bed13c145d5d9342.jpg',
  think: 'https://media1.s-nbcnews.com/i/newscms/2019_03/2717321/think_c013724f62a64c50bed13c145d5d9342.jpg',
  msnbc: 'https://media1.s-nbcnews.com/i/newscms/2019_03/2717311/msnbc_c013724f62a64c50bed13c145d5d9342.jpg',
  mach: 'https://media1.s-nbcnews.com/i/newscms/2019_03/2717306/mach_c013724f62a64c50bed13c145d5d9342.jpg',
  leftfield: 'https://media2.s-nbcnews.com/i/newscms/2019_03/2717301/leftfield_c013724f62a64c50bed13c145d5d9342.jpg',
  knowyourvalue: 'https://media2.s-nbcnews.com/i/newscms/2019_03/2717296/kyv_c013724f62a64c50bed13c145d5d9342.jpg',
  globalcitizen: 'https://media1.s-nbcnews.com/i/newscms/2019_09/2717291/gc_3c671e518df04661e7f7fc18edac7759.jpg',
  better: 'https://media1.s-nbcnews.com/i/newscms/2019_03/2717286/better_c013724f62a64c50bed13c145d5d9342.jpg',
};

class WaffleTeaseImage extends React.Component {
  static propTypes = {
    vertical: PropTypes.string,
    computedValues: PropTypes.objectOf(PropTypes.any).isRequired,
    showTease: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    vertical: '',
    showTease: true,
    className: '',
  };

  getFallbackTease = (vertical) => {
    const fallbackTeaseImage = {
      alternateTeaseImages: [
        {
          aspectRatio: 'ASPECT_1X1',
          image: {
            altText: vertical,
            url: {
              primary: imageUrlMap[vertical.toLowerCase()] || '/waffleBackground.svg',
            },
          },
        },
      ],
      teaseImage: {
        altText: vertical,
      },
    };
    return fallbackTeaseImage;
  }

  render() {
    const {
      computedValues = {},
      className,
      showTease = true,
      vertical,
    } = this.props;

    const { url, alternateTeaseImages = [], teaseImage = {} } = computedValues;
    const hasLegacyTease = teaseImage && teaseImage.url && teaseImage.url.primary;
    const hasTease = (alternateTeaseImages.length || hasLegacyTease) && showTease;

    if (!hasTease) {
      Object.assign(computedValues, this.getFallbackTease(vertical));
    }

    return (
      <div className={`waffle-tease-image ${className}`} data-test="tease-img">
        <div className="waffle-tease-image__background" data-test="tease-img__loading-img" />
        <div className="waffle-tease-image__wrapper" data-test="tease-img__wrapper">
          <Picture
            responsiveFlavors={{
              s: AIMS_FLAVORS.FOCAL_460x460,
              m: AIMS_FLAVORS.FOCAL_300x300,
              xl: AIMS_FLAVORS.FOCAL_360x360,
            }}
            url={url}
            computedValues={computedValues}
          />
        </div>
      </div>
    );
  }
}

export default WaffleTeaseImage;
